import { Cancel, ClockOutline, DesignPencil, DownloadSquareOutline, SettingsProfiles } from 'iconoir-react';

// Clases de Tailwind (paleta de tailwind.config.js) para el badge de cada familia de estados
const CHIP = {
    pending: 'bg-colorseventh/20 text-yellow-800 border-colorseventh/60',
    success: 'bg-colorprimarygreen/10 text-colorprimarygreen border-colorprimarygreen/30',
    danger: 'bg-oldcolorthird text-oldcolorsecondary border-oldcolorprimary/30',
    warning: 'bg-orange-50 text-orange-700 border-orange-200',
    neutral: 'bg-colorsixth text-colorprimary border-colorfifth',
};

// Apariencia por estado (is_actived). `color` es el mismo que usa la columna ESTADO de la tabla.
export const STATE_STYLES = {
    'Por Firmar': { color: '#5C19A0', Icon: DownloadSquareOutline, chip: CHIP.pending },
    'Firmado': { color: '#528711', Icon: DesignPencil, chip: CHIP.success },
    'Recibida': { color: '#ea580c', Icon: DesignPencil, chip: CHIP.warning },
    'Rechazado': { color: '#EF4444', Icon: Cancel, chip: CHIP.danger },
    'En Proceso': { color: '#5C19A0', Icon: ClockOutline, chip: CHIP.neutral },
    'Orden creada': { color: '#528711', Icon: SettingsProfiles, chip: CHIP.success },
    'Orden en Progreso': { color: '#5C19A0', Icon: ClockOutline, chip: CHIP.neutral },
};

// Estado desconocido: se muestra con el color terciario de la paleta
export const DEFAULT_STATE_STYLE = { color: '#b386c5', Icon: ClockOutline, chip: CHIP.neutral };

export const getStateStyle = (state) => STATE_STYLES[state] || DEFAULT_STATE_STYLE;
